/**
 * Frontend mirror of functions/Shared Functions/dataNormalization.js.
 *
 * Every entry point (imports, Quick Add, webhooks) must store the SAME
 * normalized email/phone shape or duplicate detection breaks across paths.
 * Keep this logic in sync with the backend version.
 */

/**
 * Lowercase + trim. Returns '' for null/undefined.
 */
export function normalizeEmail(email) {
  if (!email) return '';
  return String(email).toLowerCase().trim();
}

/**
 * Normalize to 10-digit US format: strips formatting, drops a leading
 * country-code 1 from 11-digit numbers. Non-US lengths return digits only.
 * Returns '' for null/undefined/no digits.
 */
export function normalizePhone(phone) {
  if (!phone) return '';
  const digitsOnly = String(phone).replace(/\D/g, '');
  if (!digitsOnly) return '';
  if (digitsOnly.length === 10) return digitsOnly;
  if (digitsOnly.length === 11 && digitsOnly[0] === '1') return digitsOnly.substring(1);
  return digitsOnly;
}
